// Scroll To Target
$('.js-btn-scroll').on('click', function(e) {
  e.preventDefault();

  const $this = $(this);
  const targetTop = $($this.data('target')).offset().top
  const $header = $('.header');
  let headerH = 0;

  if ($header.length) {
    const headerPos = $header.css('position');

    if (headerPos == 'fixed') {
      headerH = $header.outerHeight();
    };
  };

  $('body,html').animate({
    scrollTop: targetTop - headerH
  }, 700);
});



// WEBPACK FOOTER //
// ../assets/js/btn-scroll.js